import { useAdminContext } from "@aix/ui"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import { AdminModelPricingPreview } from "~/components/Admin/AdminTools/AdminModelPricingPreview"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"
import { api } from "~/utils/api"

import type { ReactElement } from "react"

function AdminModelPricing() {
  const { isAdmin } = useAdminContext()
  const navigate = useNavigate()
  const ctx = api.useContext()

  const user = ctx.users.getUserWithTeam.getData()

  useEffect(() => {
    if (!isAdmin) {
      void navigate({ to: "/home" })
    }
  }, [user?.id])

  return (
    <>
      <CustomHead />

      <div>
        <AdminModelPricingPreview />
      </div>
    </>
  )
}

function AdminModelPricingWrapper() {
  return (
    <SuperAdminLayout>
      <AdminModelPricing />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/model-pricing")({
  component: AdminModelPricingWrapper,
})
